import { render } from "./EventDetail.vue?vue&type=template&id=798d621c&scoped=true&ts=true"
import script from "./EventDetail.vue?vue&type=script&lang=ts"
export * from "./EventDetail.vue?vue&type=script&lang=ts"

import "./EventDetail.vue?vue&type=style&index=0&id=798d621c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798d621c"]])

export default __exports__